/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAITokenLimitResultViewModel } from "../types/TutorAITokenLimitResultViewModel.ts";

export const tutorAITokenLimitResultViewModelSchema = z.object({
  personId: z.optional(
    z.number().int().describe("ID da pessoa cujos limites foram atualizados."),
  ),
  dailyLimit: z.optional(
    z
      .number()
      .int()
      .describe(
        "Limite diário de tokens configurado. Zero indica ausência de limite individual (aplica o padrão global).",
      ),
  ),
  weeklyLimit: z.optional(
    z
      .number()
      .int()
      .describe(
        "Limite semanal de tokens configurado. Zero indica ausência de limite individual (aplica o padrão global).",
      ),
  ),
  monthlyLimit: z.optional(
    z
      .number()
      .int()
      .describe(
        "Limite mensal de tokens configurado. Zero indica ausência de limite individual (aplica o padrão global).",
      ),
  ),
  enabled: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o controle de limites está habilitado para o aluno. Quando false, os limites configurados são ignorados.",
      ),
  ),
}) as unknown as ToZod<TutorAITokenLimitResultViewModel>;
